// Live URL :
export const BASE_URL = "https://api.nu-vio.com/api/";
export const socketConnectURL = "https://api.nu-vio.com/"

// Devlopment URL :
// export const BASE_URL = "https://dev-api.nu-vio.com/api/";

// Local URL :
// export const BASE_URL = "http://192.168.1.29:4005/api/";
// export const socketConnectURL = "http://192.168.1.29:4005/";

// Comman APIs :
export const loginAPI = "common/login";
export const forgotPasswordAPI = "common/forgot-password";
export const shareOtpAPI = "common/verify-otp";
export const setPasswordAPI = "common/reset-password";

// Admin :
export const adminLoginAPI = "admin/login";
export const coachiesAPI = "admin/all-coaches";

export const webinarAPI = "public/webinar-registration";
export const contactUsAPI = "public/contact-us";

export const coachCategoriesAPI = "public/get-categories"

export const getAllWebinarListAPI = "admin/webinar-registration-form";
export const updateCoachStatusAPI = "admin/update-coach-status";

export const createNuterraAPI = "admin/create-nuterra"
export const updateNuterraDataAPI = "admin/update-nuterra/"
export const deleteNuterraAPI = "admin/nuterra/"

// Coach SignUp
export const coachSignUpAPI = "common/register-coach";
export const getAllSubscriptionPlanAPI = "public/get-subscription-plans";

export const purchaseSubscriptionAPI = "common/add-subscription-plan";

// Bootcamp : 
export const addBootCampAPI = "admin/create-bootcamp";
export const updateBootCampAPI = "admin/bootcamp/";

export const updateBootcampImagesAPI = "admin/update-bootcamp-image/";
export const bootcampsAPI = "admin/bootcamp";
export const workNuterraBookingsAPI = "admin/reserve-spots";
export const toggleBootcampStatusAPI = "admin/toggle-bootcamp-status/";
export const toggleNuterraStatusAPI = "admin/toggle-nuterra-status/";
export const toggleWorkshopStatusAPI = "admin/toggle-workshop-status/";
export const cloneBootcampAPI = "admin/clone-bootcamp";

export const commonBootcamps = "common/bootcamp";
// export const commonBootcamps ="admin/bootcamp"

// Bootcamp purchase
export const purchaseBootCampAPI = "public/bootcamp-booking";
export const waitListBootCampAPI = "public/bootcamp-waiting-list";

export const getBookingListAPI = "admin/bootcamp-booking-history";

// Webinar
export const createWebinarAPI = "admin/create-webinar";
export const updateWebinarAPI = "admin/update-webinar";
export const createSpeakerImageAPI = "admin/create-webinar-speakers";
export const updateSpeakerImageAPI = "admin/update-webinar-speakers";

// Workshop
export const workshopAPI = "coach/my-workshops"
export const workshopBookingsAPI = "coach/reserve-spots?type=workshop"
export const reserveSpotAPI = "public/spot-reserve"
export const createWorkshopAPI = "admin/create-workshop";
export const updateWorkshopAPI = "admin/update-workshop";
export const coachToggleWorkshopStatusAPI = "coach/toggle-workshop-status/";
export const createWorkshopSpeakerImageAPI = "admin/create-workshop-speakers";
export const updateWorkshopSpeakerImageAPI = "admin/update-workshop-speakers";

// Webinar
export const fetchAllWebinarAPI = "public/webinar";
export const fetchNuterrasAPI = "public/get-future-nuterra";
export const coachWebinarAPI = "coach/my-webinars";
export const coachBookedWebinarAPI = "coach/webinar-booked-users";
export const createCoachWebinarAPI = "coach/create-webinar";
export const updateCoachWebinarAPI = "coach/update-webinar";
export const createCoachSpeakerImageAPI = "coach/create-webinar-speakers";
export const deleteCoachWebinarAPI = "coach/webinar/";
export const deleteCoachWorkShopAPI = "coach/workshop/";

export const fetchAdminAllWebinar = "admin/all-webinar";

export const deleyeWebinarAPI = "admin/webinar/";
export const deleyeWorkshopAPI = "admin/workshop/";
export const updateCoachSpeakerImageAPI = "coach/update-webinar-speakers";

// admin/all-workshop

export const getAllWorkshopAPI = "admin/all-workshop";

// public
export const getAllWorkshopPublicAPI = "public/workshop";

export const createCoachWorkshopSpeakerImageAPI = "coach/create-workshop-speakers";
export const updateCoachWorkshopSpeakerImageAPI = "coach/update-workshop-speakers";

export const createCoachWorkshopAPI = "coach/create-workshop";
export const updateCoachWorkshopAPI = "coach/update-workshop";

export const updateAdminWorkshopSpeakerImageAPI = "admin/update-workshop-speakers";
export const updateAdminWorkshopAPI = "admin/update-workshop";

// Coach Details
export const getAllCoachListEndPointURL = "public/all-coaches";

export const deleteAccountAPI = "common/delete-account";
export const changePasswordAPI = "common/change-password";
export const disableAccountAPI = "common/disable-account";
export const getSubscriptionDataAPI = "common/subscriptions";

export const cancelPlanAPI = "common/switch-auto-pay";

export const getCoachProfileDataEndPointURL = "common/profile";
export const updateCoachProfileDataEndPointURL = "coach/profile";
export const updateCoachProfileExtendedEndPointURL = "coach/update-coach-profile";

// Freelancer

export const freelancerSignUpAPI = "public/register-open-talent";
export const freelancerSubscriptionsAPI = "public/get-subscription-plans-open-talent";
export const profileStep1SubmitAPI = "open-talent/update-step-2";
export const profileStep2SubmitAPI = "open-talent/update-step-3";
export const getAllFreelancersEndPointURL = "admin/all-open-talent";
export const profileStep3SubmitAPI = "open-talent/update-step-4";
export const profileStep4SubmitAPI = "open-talent/update-step-5"
export const freelancerProfileAPI = "common/profile";
export const freelancerUpdateProfileStepAPI = "open-talent/update-profile-step";
export const offersAPI = "public/all-offers";
export const nuterraAPI = "admin/get-all-nuterra";

export const createOfferEndPointURL = "coach/offer";
export const fetchAllCoachOfferEndPointURL = "coach/offer";

// Coach E-Books
export const fetchAllCoachEBookListEndPointURL = "public/contents";
// export const fetchAllCoachOfferEndPointURL = "coach/offer";
export const contentAPI = "coach/content";


// Coach Workshop
export const fetchAllCoachWorkshopEndPointURL = "public/workshop?user_id=";
export const adminContentAPI = "admin/contents";
export const adminProjectAPI = "admin/projects";

export const getCoachByIdEndPointURL = "public/coach/";

export const getAllCoachEBookListEndPointURL = "public/content-by-user/";
export const freelancerUpdateProfileDataAPI = "open-talent/profile";

export const coachingDashboardAPI = "coach/offer-dashboard";

// Hire Talent :

export const hireTalentSignUpAPI = "hire-talent/register-hire-talent";
export const addCompanyDetailsAPI = "hire-talent/add-company";
export const hireTalentSection2API = "hire-talent/update-section-2";
export const hireTalentSection3API = "hire-talent/update-section-3";
export const hireTalentSection4API = "hire-talent/update-section-4";
export const hireTalentProfileAPI = "common/profile";
export const hireTalentUpdateProfileStepAPI = "hire-talent/update-profile-step";

export const addPostJobHireTalant = "hire-talent/create-job";
export const updatePostJobHireTalant = "hire-talent/edit-job/";

export const deleteJobPostEndPointURL = "hire-talent/delete-job/";
export const getMyPostJobListEndPointURL = "hire-talent/my-posted-jobs";

// get Post Jobs 
export const getPostJobsToFreelancers = "public/all-active-jobs";

export const projectsAPI = "hire-talent/my-projects"
export const projectDetailsAPI = "hire-talent/project/"
export const freelancerprojectDetailsAPI = "open-talent/project/"
export const sendInvitationToFreelancerAPI = "hire-talent/invite-freelancer"
export const markAsCompleteAPI = "hire-talent/mark-project-completed"
export const recommendedFreelancerAPI = "hire-talent/my-projects/matching-talents"

export const freelancerProjectsAPI = "open-talent/my-project-invites"
export const addProjectListEndPointURL = "hire-talent/create-project";

// project status update
export const updateProjectStatusEndPointURL = "admin/project/action";
export const adminProjectDetailsAPI = "admin/project/";
export const adminProjectFreelancerAPI = "admin/project/matching/";
export const inviteToProjectAPI = "admin/invite-freelancer";
export const manageInvitationAPI = "open-talent/respond-invite"
export const markAsCompleteProjectAPI = "open-talent/mark-project-completed";
export const addAdminProjectEndPointURL = "admin/create-project";

export const markStartProjectEndPointURL = "open-talent/respond-invite";

export const markAdminProjectCompleteEndPointURL = "admin/mark-project-completed";

export const fetchWorkshopDetailsByIdEndPointURL = "public/workshop/";
export const fetchWebinarDetailsByIdEndPointURL = "public/webinar/";

export const fetchNuterraDetailsByIdEndPointUR = "public/get-nuterra/";

// Hire Talent Recommended
export const fetchHireTalentRecommendedEndPointURL = "hire-talent/projects-matching-talents/";
export const uploadDeliveableProjectHireTalentEndPointURL = "hire-talent/upload-deliverable";
export const uploadDeliveableProjectFindJobEndPointURL = "open-talent/upload-deliverable";
export const uploadDeliveableProjectAdminEndPointURL = "admin/upload-deliverable";

export const fetchAdminDeliveableProjectDetailsEndPointURL = "admin/project/deliverables/";
export const fetchHireTalentDeliveableProjectDetailsEndPointURL = "hire-talent/project/deliverables/";
export const fetchFreelancerDeliveableProjectDetailsEndPointURL = "open-talent/project/deliverables/";

// Chat :
export const attachFileAPI = "socket/upload-file"

export const coachVerifyCreatePasswordEndPointURL = "coach/create-password/";


// Admin Profile
export const adminProfileEndPointURL = "admin/profile";
export const adminChangePasswordEndPointURL = "admin/change-password";
